import React from "react"
import Records from "../../components/record/Records"
import { Paper } from "material-ui"
import AuthenticationStore from "../../stores/AuthenticationStore"
import autobind from "class-autobind"
import { IRecord, IRecordSearch, ERecordSearchFilter, ERecordPageType, IDateRange, EDayOfWeek, IPayrollPayCalendar } from "../../models"
import * as api from "../../api"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import strings from "../../localization/strings"
import * as utils from "../../helpers/utils"
import * as timeHelper from "../../helpers/timeHelper"
import moment from "moment"
interface IState {
  selectedFilter: ERecordSearchFilter
  records: IRecord[]
  total: number
  offset: number
  limit: number
  loading: boolean
  dateRange: IDateRange
}

export default class TopRecords extends React.Component<null, IState> {
  constructor(props) {
    super(props)
    const storedRecordSelectedFilter = utils.getCookie("RecordSelectedFilter") as ERecordSearchFilter
    const thisWeek = timeHelper.getWeekRange(EDayOfWeek.Monday, moment())
    this.state = {
      selectedFilter: storedRecordSelectedFilter || ERecordSearchFilter.All,
      records: [],
      total: 0,
      offset: 0,
      limit: 20,
      loading: true,
      dateRange: { StartDate: thisWeek.startDate, EndDate: thisWeek.endDate }
    }
    autobind(this)
  }

  componentDidMount() {
    document.title = `${strings.Records} | ${strings.Findd_Grandd_Central}`
    this.getRecords()
    HierarchySettingsStore.on("global_change", this.getRecords)
  }

  componentWillUnmount() {
    HierarchySettingsStore.removeListener("global_change", this.getRecords)
  }

  getRecords() {
    this.setState({ loading: true }, () =>
      api.getRecords(AuthenticationStore.getCookieAccountId(), this.state.offset / this.state.limit, this.state.limit, moment(this.state.dateRange.StartDate).utc(true).format(), moment(this.state.dateRange.EndDate).utc(true).format(), HierarchySettingsStore.getGlobalLevelItemFilterId(), true, this.state.selectedFilter).then(res => {
        const recordSearch = res.data as IRecordSearch
        this.setState({
          loading: false,
          records: recordSearch.Documents,
          total: recordSearch.TotalDocumentCount
        })
      })
    )
  }

  onPageClick(offset) {
    this.setState({ offset, loading: true }, () =>
      this.getRecords()
    )
  }

  onLimitChange(limit) {
    this.setState({ limit, offset: 0, loading: true }, () =>
      this.getRecords()
    )
  }

  render() {
    return (
      <div className="page-container Records" style={{ position: "relative" }}>
        <div className="page-container-parent">
          <Paper zDepth={1} className="page-paper">
            <Records
              loading={this.state.loading}
              pageMode={ERecordPageType.TopMenu}
              selectedFilter={this.state.selectedFilter}
              dateRange={this.state.dateRange}
              total={this.state.total}
              offset={this.state.offset}
              limit={this.state.limit}
              limitOptions={[20, 50, 100]}
              records={this.state.records}
              onPageClick={offset => this.setState({ offset }, () => this.getRecords())}
              onLimitChange={limit => this.setState({ limit, offset: 0 }, () => this.getRecords())}
              handleChangeSelectedFilter={selectedFilter => {
                localStorage.setItem("findd_RecordSelectedFilter", selectedFilter)
                this.setState({ selectedFilter, offset: 0 }, () => this.getRecords())
              }}
              handleChangeDateRange={dateRange => {
                this.setState({ dateRange, offset: 0 }, () => this.getRecords())
              }}
              reload={initOffset => initOffset ?
                this.setState({ offset: 0 }, () => this.getRecords()) :
                this.getRecords()
              }
            />
          </Paper>
        </div>
      </div>
    )
  }
}
